<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="userData.permissions['view_student_attendance'] == 1"
    >
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="mb-2 float-end">
                  <div>
                    <b-button v-b-modal.edit-products size="lg" variant="info"
                      ><i class="mdi mdi-plus"></i> Start Roll Call</b-button
                    >
                  </div>
                </div>
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Class">
                    <v-select
                      :options="schoolclasses"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(addedby)="data">{{
                    data.item.addedby.full_name
                  }}</template>
                  <template #cell(schoolclass)="data"
                    >{{ data.item.schoolclass.name }}
                    {{ data.item.schoolstream.name }}</template
                  >
                  <template #cell(schoolterm)="data">{{
                    data.item.schoolterm.name
                  }}</template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <span v-if="data.item.status == 1">
                        <router-link
                          :to="{
                            path: '/viewstudent',
                            query: { id: data.item.attendance_id },
                          }"
                          type="button"
                          class="btn-sm btn btn-secondary"
                        >
                          <i class="mdi mdi-clipboard-text"></i>
                          View</router-link
                        >
                        <b-button
                          @click="edit(data.item.id)"
                          type="button"
                          class="btn-sm btn"
                          variant="info"
                          v-b-modal.end-attendance
                        >
                          <i class="mdi mdi-lock"></i> End
                        </b-button>
                      </span>
                      <span v-else>
                        <b-button
                          type="button"
                          class="btn-sm btn"
                          variant="success"
                          ><i class="mdi mdi-check"></i> Closed
                        </b-button>
                      </span>
                    </div>
                  </template>
                </b-table>
              </div>

              <b-modal
                id="edit-products"
                centered
                title="Capture Attendance"
                title-class="font-14"
                hide-footer
              >
                <form @submit.prevent="editproducts">
                  <div class="form-group mb-2">
                    <input v-model="id" type="hidden" />
                    <label> School Term</label>
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                    <label>Year</label>
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                    <label>Class</label>
                    <v-select
                      :options="schoolclasses"
                      @input="FilterStream"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                    <label>Stream</label>
                    <v-select
                      :options="schoolstreams"
                      placeholder="Select Stream"
                      v-model="schoolstream"
                      label="name"
                    ></v-select>
                  </div>
                  <div class="form-group d-flex justify-content-end">
                    <b-button
                      type="button"
                      class="btn w-30"
                      variant="secondary"
                      @click="$bvModal.hide('edit-products')"
                      >Close</b-button
                    >
                    <b-button
                      type="submit"
                      class="btn ms-1 w-30"
                      variant="primary"
                      ><i class="fas fa-check-circle"></i> Start</b-button
                    >
                  </div>
                </form>
              </b-modal>

              <b-modal
                id="end-attendance"
                centered
                title="End Attendance"
                title-class="font-14"
                hide-footer
              >
                <form @submit.prevent="endattendance">
                  <div class="form-group mb-2">
                    <input v-model="id" type="hidden" />
                    Are you sure you want to close the class Rollcall ?
                  </div>
                  <div class="form-group d-flex justify-content-end">
                    <b-button
                      type="button"
                      class="btn w-30"
                      variant="secondary"
                      @click="$bvModal.hide('end-attendance')"
                      >Close</b-button
                    >
                    <b-button
                      type="submit"
                      class="btn ms-1 w-30"
                      variant="primary"
                      ><i class="fas fa-check-circle"></i> End</b-button
                    >
                  </div>
                </form>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentattendanceComputed,
  studentattendanceMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Student Attendance ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: " Student Roll Call",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Student Roll Call", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "schoolclass", label: "Class", visible: true },
        { key: "schoolterm", label: "Term", visible: true },
        { key: "year", label: "Year ", visible: true },
        { key: "attendance_date", label: "Attendance date ", visible: true },
        { key: "addedby", label: "Staff ", visible: true },
        { key: "starttime", label: "Time started", visible: true },
        { key: "endtime", label: "Time ended", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      staff: "",
      date: "",
      start: "",
      end: "",
      schoolterm: "",
      schoolclass: "",
      schoolstream: "",
      schoolstreams: [],
      year: new Date().getFullYear(),
      loader: false,
    };
  },
  computed: {
    ...studentattendanceComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.studentattendances.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.studentattendances.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.studentattendances.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.fetchStudentattendances();
    this.FilterData();
    this.TotalRows = this.studentattendances.length;
    this.isBusy = false;
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...studentattendanceMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async FilterStream() {
      let url = `/findschoolstream/${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.schoolstreams = response.data.streams;
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },

    async update() {
      let formData = new FormData();
      let url = "/updatestudentattendance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.FetchData();
        }
      });
    },
    edit(id) {
      this.id = id;
      this.$bvModal.show("end-attendance");
    },

    async editproducts() {
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("year", this.year);
      formData.append("schoolstream", this.schoolstream.id);
      let url = "/startattendance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudentattendances();
          this.$bvModal.hide("edit-products");
        }
      });
    },
    async endattendance() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/endstudentattendance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudentattendances();
          this.$bvModal.hide("end-attendance");
        }
      });
    },
    FilterData() {
      this.filterAttendance({
        schoolterm: this.schoolterm.id,
        year: this.year,
        schoolclass: this.schoolclass.id,
      });
    },
  },
};
</script>
